// ── RSVP status helpers shared by the guest form and the admin console ───────
export const EMPTY_STATUS = {
  rehearsal:    null,   // 'yes' | 'no' (only asked of invited parties — see guestList rehearsal flag)
  welcomeParty: null,   // 'yes' | 'no'
  attending:    null,   // 'accepts' | 'declines' (wedding Friday)
  meal:         null,   // 'fish' | 'meat' | 'vegetarian'
  dietary:      null,   // 'yes' | 'no'
  dietaryNote:  '',
};

export const attendsAnyEvent = s =>
  s?.rehearsal === 'yes' || s?.welcomeParty === 'yes' || s?.attending === 'accepts';

// Drop answers that no longer apply (e.g. meal picked, then wedding declined)
export function sanitizeStatus(s, rehearsalInvited) {
  const out = { ...EMPTY_STATUS, ...s };
  if (!rehearsalInvited) out.rehearsal = null;
  if (out.attending !== 'accepts') out.meal = null;
  if (!attendsAnyEvent(out)) out.dietary = null;
  if (out.dietary !== 'yes') out.dietaryNote = '';
  return out;
}

// Firestore document ID: sanitize the party's formal name for use as a doc key
export function entryToDocId(entry) {
  return entry.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
}
